var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisually(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 1.66663L31.3335 28.3333M21.3335 18.7268C20.4489 19.5185 19.2808 20 18.0002 20C15.2387 20 13.0002 17.7614 13.0002 15C13.0002 13.7194 13.4816 12.5512 14.2733 11.6666M30.6798 21.0128C31.632 20.1837 32.4839 19.3498 33.2173 18.5781C35.15 16.5447 35.15 13.4552 33.2173 11.4218C29.9577 7.99218 24.3594 3.33329 18.0002 3.33329C16.5145 3.33329 15.0704 3.58756 13.688 4.02103M8.8335 6.33893C6.40256 7.89069 4.32956 9.7946 2.78301 11.4218C0.850327 13.4552 0.850326 16.5447 2.78301 18.5781C6.04265 22.0077 11.641 26.6666 18.0002 26.6666C21.1136 26.6666 24.0447 25.5498 26.6082 24.0073",
    stroke: "#25A249",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisually);
export default __webpack_public_path__ + "static/media/visually.1c49f5be21a1a84e8923768045d80aab.svg";
export { ForwardRef as ReactComponent };